export default __webpack_public_path__ + "static/media/charge_pump_negative_0_diodes.f95bcf3e.svg";